<template>
  <b-form-input
    :class="className"
    :readonly="readOnly"
    :max-length="maxLength"
    v-model="localValue"
    :type="inputType"
    :placeholder="placeholder"
    :name="name"
    :id="name"
    :min="min"
    :max="maxValue"
    :step="step"
    :required="required"
    :autocomplete="autocomplete"
    @input="(inputValue) => $emit('field-input', {name, inputValue})"
  />
</template>

<script>
  export default {
    name: "FormFieldInput",
    props: {
      className: {
        type: String,
        default: 'rounded'
      },
      readOnly: {
        type: Boolean,
        default: false
      },
      maxLength: {
        type: Number,
      },
      value: {
        required: true
      },
      type: {
        type: String,
        default: 'input'
      },
      placeholder: {
        type: String,
        default: ''
      },
      name: {
        type: String,
      },
      id: {
        type: String
      },
      min: {
        type: Number
      },
      max: {
        type: Number
      },
      step: {
        type: Number
      },
      required: {
        type: Boolean,
        default: false
      },
      passwordVisible: {
        type: Boolean,
        default: false
      },
      autocomplete: {
        type: String,
        default: 'on'
      }
    },
    computed: {
      inputType() {
        if (this.type === 'password' && this.passwordVisible) {
          return 'text';
        } else if (this.type === 'discount') {
          return 'number'
        }

        return this.type;
      },
      localValue: {
        get() {
          return this.value;
        },
        set(value) {
          this.$emit('input', value);
        },
      },
      maxValue() {
        if (!this.max && this.type === 'discount') {
          return 100;
        }

        return this.max;
      }
    }
  }
</script>
